import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Badge, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { IRegistration } from '../../../store/registrations/interfaces'
import { updatePriority } from '../../../store/registrations/registrations'
import { RootState } from '../../../store'
import { getExistingRegistrations } from '../../../store/registrations/selectors'
import { isTabletOrMobileQuery, isTabletOrSmallDesktopQuery } from '../../../utils'
import { useMediaQuery } from 'react-responsive'

const Priority = (props: {
  registration: IRegistration
  editable: boolean
}) => {
  const dispatch = useDispatch()
  const { registration, editable } = props
  const { list: registrations } = useSelector(
    (state: RootState) => state.registrations
  )
  const existingRegistrations = useSelector(getExistingRegistrations)
  const maxPriority = Math.max(...existingRegistrations.map((reg) => reg.priority))
  const canIncrement = registration.priority > maxPriority + 1

  const incrementPriority = () => {
    if(canIncrement) {
      dispatch(
        updatePriority({ eventId: registration.event.event_id, dPriority: +1 }),
      )
    }
  }

  const decrementPriority = () =>
    dispatch(
      updatePriority({ eventId: registration.event.event_id, dPriority: -1 }),
    )

  const isTabletOrMobile = useMediaQuery(isTabletOrMobileQuery)
  const isTabletOrSmallDesktop = useMediaQuery(isTabletOrSmallDesktopQuery);

  const { loadedFromBackend } = registration;
  const [isLast, setIsLast] = useState(registration.priority === registrations.length - 1);
  const [isFirst, setIsFirst] = useState(registration.priority === 0);

  const isVertical = isTabletOrMobile || isTabletOrSmallDesktop;

  useEffect(() => {
    setIsLast(registration.priority === registrations.length - 1);
    setIsFirst(registration.priority === 0);
  }, [registration.priority, registrations.length]);
  
  const shouldRenderIncrement = editable && registrations.length > 1 && !isFirst
  const shouldRenderDecrement = editable && registrations.length > 1 && !isLast

  return (
    <span className={`d-flex align-items-center ${
      isTabletOrMobile ? '' : 'justify-content-between'
    }`}>
      Priorität&nbsp;
      <div className='d-flex align-items-center ml-5'>
        {(loadedFromBackend || !canIncrement) ? (
          <></>
        ) : (
          <Button
            hidden={!shouldRenderIncrement}
            className='mr-2 my-0 text-dark h2 border-0 bg-transparent'
            aria-label='Priorität der Anmeldung verringern'
            onClick={() => {
              if (editable && registrations.length > 1 && !isFirst) {
                incrementPriority()
              }
            }}
          >
            <FontAwesomeIcon
              color={
                editable && registrations.length > 1 && !isFirst
                  ? undefined
                  : 'transparent'
              }
              icon={
                isVertical ? 'caret-up' : 'caret-left'}
              role='presentation'
              size='lg'
            />
          </Button>
        )}
        <h4 style={{ overflow: 'auto' }}>
          <Badge className='dark-primary-background' pill variant='primary'>
            {registration.priority + 1}
          </Badge>
        </h4>
        {(loadedFromBackend) ? (
          <></>
        ) : (
          <Button
            hidden={!shouldRenderDecrement}
            className='ml-2 my-0 text-dark h2 border-0 bg-transparent'
            aria-label='Priorität der Anmeldung erhöhen'
            disabled={(loadedFromBackend)}
            onClick={() => {
              if (editable && registrations.length > 1 && !isLast) {
                decrementPriority()
              }
            }}
          >
            <FontAwesomeIcon
              color={
                editable && registrations.length > 1 && !isLast
                  ? undefined
                  : 'transparent'
              }
              icon={
                isVertical ? 'caret-down' : 'caret-right'}
              role='presentation'
              size='lg'
            />
          </Button>
        )}
      </div>
    </span>
  )
}

export default Priority
